var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('product-analytics-single-view',{attrs:{"report-key":_vm.reportKey}})}
var staticRenderFns = []

export { render, staticRenderFns }